module.exports = __webpack_public_path__ + "img/sandbox-2.0b4f5748.svg";